// extracted by mini-css-extract-plugin
module.exports = {"blue":"button_blue__spIp0","button":"button_button__9t2Tl"};